import React, { useContext } from 'react'
import { ApiGetCall } from '../../JS/Connector';
import { escapeCsv, formatDateToMMDDYYYY, LogInSchoolID } from '../../JS/Common';
import AlertsComp from '../../Components/AlertsComp';
import { UserContext } from '../../App';
import useConfig from '../../Hooks/useConfig';

export default function DownloadOpenTicketReport({ setAlerts }) {
    const { user_no } = useConfig();
    const { UserData } = useContext(UserContext);
    async function GetHelpdeskReportData() {
        await ApiGetCall(`/reports/helpdesk-by-building?schoolId=${LogInSchoolID}`).then((result) => {
            if (result == undefined || result == "") {
                alert("Something went wrong");
            } else {
                const responseRs = JSON.parse(result);
                downloadCsv(responseRs?.helpdesk_ticket_by_buildingfor_report?.pdf_data);
            }
        });
    }
    const downloadCsv = (helpdeskReportData) => {
        const csvContent = [];
        const gradeMap = new Map();
        helpdeskReportData?.forEach((buildingTickets) => {
            if (buildingTickets.length > 0) {
                var building = "";
                if (UserData.helpdeskUpdatedFlag) {
                    building = buildingTickets[0]?.building?.name || buildingTickets[0]?.building_name || '-' // Get the building name
                } else {
                    building = buildingTickets[0]?.building?.name || buildingTickets[0]?.other_building_name || '-' // Get the building name
                }
                if (!gradeMap.has(building)) {
                    gradeMap.set(building, []);
                }
                buildingTickets.forEach((ticket) => {
                    var tickettype = "";
                    if (UserData.helpdeskUpdatedFlag) {
                        tickettype = ticket?.type?.name;
                    } else {
                        tickettype = ticket?.type == 1 ? "Technology" : "Maintenance"
                    }
                    const rowData = {
                        'Ticket Number': ticket.request_num || ticket.support_ticket_num,
                        'Subject': escapeCsv(ticket.title),
                        'Name': escapeCsv(ticket?.name),
                        'Email': ticket?.email,
                        'Room': ticket?.room_name ? escapeCsv(ticket?.room_name) : ticket.room ? escapeCsv(ticket?.room?.name) : '-',
                        [user_no]: ticket?.student_no || ticket?.student_num,
                        'Created at': ticket.created_at ? formatDateToMMDDYYYY(ticket.created_at) : '-',
                        'Assigned To': ticket?.assigned_flag == 1 ?
                            ticket?.usergroup?.name :
                            ticket?.assigned_flag == 2 ?
                                `${ticket?.user?.first_name} ${ticket?.user?.last_name}`
                                : ticket?.user ? `${ticket?.user?.first_name} ${ticket?.user?.last_name}` : '-',  // Format the date
                        'Ticket Type': tickettype,
                    };

                    gradeMap.get(building).push(rowData);
                });
            }
        });


        gradeMap.forEach((gradeData, building) => {
            csvContent.push([`Building: ${building}`]);
            const headers = ['Ticket Number', 'Subject', 'Name', 'Email', 'Room',
                user_no,
                'Created at', 'Assigned To', 'Ticket Type'];
            csvContent.push(headers);
            gradeData.forEach((rowData) => {
                const values = Object.values(rowData);
                csvContent.push(values);
            });
            csvContent.push([]);
        });

        if (csvContent.length > 0) {
            const csvString = csvContent.map(row => row.join(',')).join('\n'); // Convert to CSV string
            const blob = new Blob([csvString], { type: 'text/csv' });  // Create a Blob with the CSV content
            const link = document.createElement('a');
            link.href = URL.createObjectURL(blob);
            link.download = 'OpenTicketsReport.csv';
            document.body.appendChild(link);
            link.click();
            document.body.removeChild(link);
        } else {
            setAlerts(<AlertsComp show={true} variant="danger" msg={"No Data Found"} />);
            setTimeout(() => {
                setAlerts(<AlertsComp show={false} />)
            }, 1500);
        }
    };
    return (
        <label className='BorderBtn me-1 text-center' title="Open Tickets Report" onClick={GetHelpdeskReportData}>
            <img src='/images/downloadPlan.svg' className='img-fluid pe-2' />Open Tickets Report
        </label>
    )
}
